import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
var componentClass = 'icon';
export var SvgIcon = function (props) {
    var _a;
    var children = props.children, className = props.className, disabled = props.disabled, _b = props.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, size = props.size, otherProps = __rest(props, ["children", "className", "disabled", "viewBox", "size"]);
    var classes = cx(bcx(componentClass, (_a = {},
        _a["".concat(size)] = !!size,
        _a.disabled = disabled,
        _a)), className);
    return (React.createElement("svg", __assign({}, otherProps, { viewBox: viewBox, className: classes }), children));
};
//# sourceMappingURL=SvgIcon.js.map